// extracted by mini-css-extract-plugin
module.exports = {"ArticlePage__Title":"ArticlePage_ArticlePage__Title__vEAlL"};